import React, { useEffect, useState, forwardRef } from 'react';
import { useContentManager } from '../../../../../hooks/useManagers';
import BitmovinPlayer from './BitmovinPlayer.js';
import './index.scss';

export default forwardRef(function Player({ content, onVideoEnded, useBitmovinPlayer, startSeconds }, ref) {
    const [playerSrc, setPlayerSrc] = useState(null);
    const [videoEnded, setVideoEnded] = useState(false);
    const contentMgr = useContentManager();
    const fileUrl = contentMgr?.SelectedContent?.FileUrl;

    useEffect(() => {
        if (fileUrl) {
            setPlayerSrc([{ src: fileUrl, type: "application/vnd.ms-sstr+xml" }]);
        }
    }, [fileUrl]);

    useEffect(() => {
        if (videoEnded && onVideoEnded) {
            onVideoEnded(content);
        }
    }, [videoEnded, content, onVideoEnded]);

    useEffect(() => {
        // This effect can be removed if useBitmovinPlayer is not used
    }, [useBitmovinPlayer])

    return (
        <>
            <div className="videoPlayerFrame">
                {(playerSrc !== null && (playerSrc !== false)) && (
                    <>
                        <>
                        <div className='video-player'>
                            <div id='player-wrapper'>
                                <BitmovinPlayer ref={ref} content={content} currentTimeStamp={startSeconds ?? 0}/>
                            </div>
                        </div>
                        </> 
                    </>
                )}
                
            </div>

        </>
    );
});
